import { Box, Button, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { ContentContainer } from "./components/styles"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"
import { ROUTES_PATHS } from "../../utils/constants"


const FailedIdentification = () => {
  const navigate = useNavigate()
  
  const handleCloseButtonClick = () => {
    navigate("/quit")
  }

  const handleAgainButtonClick = () => {
    navigate(`/${ROUTES_PATHS.topUpMbankAccount}/identification/uprid`)
  }

  return (
    <Box sx={ContentContainer}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        height="100%"
        pb="150px"
        gap={4}
      >
        <IconBox size="lg">
          <UIIcon iconName="errorTransfer" size={80} />
        </IconBox>

        <Typography variant="h3" fontWeight={700} textAlign="center">
          Введённые вами данные не <br />
          прошли проверку
        </Typography>
      </Box>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleCloseButtonClick}
        >
          Закрыть
        </Button>
        <Button
          variant="contained"
          onClick={handleAgainButtonClick}
        >
          Попробовать еще раз
        </Button>
      </Box>
    </Box>
  )
}

export default FailedIdentification
